export default __webpack_public_path__ + "static/media/CONTOH-KTP.2e024cd8.jpg";